<div class="image-wrapper">
  <img [src]="imageUrl" alt="Image" />
  <div class="top-left-text">{{ topLeftText }}</div>
  <div class="bottom-center-text">{{ bottomCenterText }}</div>
</div>
